import Button from "app/components/shared/Button";
import { ExampleSummary } from "app/components/shared/Examples/ExampleSummary";
import { Example } from "app/components/shared/Examples/useExamples";
import Icon from "app/components/shared/Icon";

import { CodeBlock, CodeBlockHeader } from "../CodeBlock";
import { Markdown } from "../Markdown";

export function ExampleDetail({ example, onClear }: { example: Example; onClear: () => void }) {
  function addToPipeline() {
    if (!example.yaml_config) {
      return;
    }

    const codemirror = document.querySelector(".CodeMirror") as {
      CodeMirror: { setValue: (value: string) => void };
    } | null;

    if (codemirror) {
      codemirror?.CodeMirror?.setValue(example.yaml_config);
    }
  }

  return (
    <>
      <div className="sticky -top-3 z-10 -mx-3 -mt-3">
        <div className="flex h-[39px] items-center gap-2 border-b border-gray/50 bg-white/90 px-3 backdrop-blur">
          <button
            onClick={onClear}
            className="-mx-2 flex h-7 items-center gap-1 rounded px-2 font-medium hover:bg-gray-200"
          >
            <Icon icon="heroicons/16/solid/arrow-left" className="block size-4" /> Back
          </button>
        </div>
      </div>

      <ExampleSummary example={example} />

      <h2 className="my-0 text-base font-semibold">Steps</h2>

      {example.yaml_config && (
        <>
          <div>
            <CodeBlockHeader>.buildkite/pipeline.yml</CodeBlockHeader>
            <CodeBlock>{example.yaml_config}</CodeBlock>
          </div>

          <Button
            theme="small"
            type="button"
            className="gap-1 self-start font-medium"
            onClick={addToPipeline}
          >
            <Icon icon="custom/outline/clipboard-copy" className="block size-4" />
            Add to pipeline
          </Button>
        </>
      )}

      <Markdown>{example.documentation}</Markdown>
    </>
  );
}
